import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/core/services/common-service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/App.state';
import * as token from 'src/app/store/actions/authToken.actions';
import { selectAuthToken } from 'src/app/store/reducers/authToken.reducer';

@Component({
    selector: 'app-redirect-pdf-url',
    templateUrl: './redirect-pdf-url.component.html',
    standalone: false
})
export class RedirectPdfurlComponent implements OnInit {
  shortId: string;
  enteredOTP;
  mobilenumber: string;


  constructor(private route: ActivatedRoute, private commonService: CommonService, private store: Store<AppState>) { }

  ngOnInit() {
    this.shortId = this.route.snapshot.paramMap.get("shortId");
    this.getSilentToken();

    //window.location.href = environment.serviceBaseUrl + 'api/short/' + this.shortId;

  }


  getSilentToken() {
    this.shortId = this.route.snapshot.paramMap.get("shortId");
    if (this.shortId != undefined) {
      this.shortId = this.shortId.substring(0, 7);
    }

    this.commonService.returnLongUrl(this.shortId).subscribe(resLongUrl => {
      if (resLongUrl) {
        this.store.dispatch(new token.AuthToken(resLongUrl['responseId']));
        sessionStorage.setItem("clientToken", resLongUrl['responseId']);
        this.commonService.callActUrl(resLongUrl["actUrl"]).subscribe(resFromActUrl => {
          if (resFromActUrl) {
            if (resFromActUrl["fileName"] && resFromActUrl["base64String"]) {
              this.downloadAnyBase64File("application/pdf", resFromActUrl["base64String"], resFromActUrl["fileName"]);
            }
          }
        })

      }
    });
  }



  downloadAnyBase64File(contentType: string, base64Data: string, fileName: string): void {
    // Convert base64 string to a byte array
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    // Convert each byte character to a byte
    for (let offset = 0; offset < byteCharacters.length; offset++) {
      const byte = byteCharacters.charCodeAt(offset);
      byteArrays.push(byte);
    }

    const blob = new Blob([new Uint8Array(byteArrays)], { type: contentType });

    const blobUrl = URL.createObjectURL(blob);

    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = fileName;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(blobUrl);
  }

}
